export default __webpack_public_path__ + "static/media/instagram-explore.a13ab71c.jpg";